/**
 * The invitation email's sign-in link: `/login?email=<address>&name=<full name>`.
 * `name` is only there when the admin typed one on the invite.
 */
export const INVITE_EMAIL_PARAM = 'email';
export const INVITE_NAME_PARAM = 'name';

/** An invite never carries a longer name, so a longer one did not come from an invite. */
export const MAX_INVITE_NAME_LENGTH = 121;

export interface InvitePrefill {
    /** Trimmed and lower-cased, as the email field shows it. */
    email: string;
    /** Absent when the link has no usable name. */
    name?: string;
}

export const normalizeEmail = (address: string): string => address.trim().toLowerCase();

/**
 * What an invitation link carries, or null when it carries no address. The name
 * is only kept alongside an address: it belongs to that invite and to nobody else.
 */
export const readInvitePrefill = (params: URLSearchParams): InvitePrefill | null => {
    const email = normalizeEmail(params.get(INVITE_EMAIL_PARAM) ?? '');
    if (!email) return null;

    const name = (params.get(INVITE_NAME_PARAM) ?? '').trim();
    const usable = name.length > 0 && name.length <= MAX_INVITE_NAME_LENGTH;
    return usable ? { email, name } : { email };
};
